import {
    FC,
    useEffect,
    useMemo,
    useState,
} from 'react'
import DayPicker from 'react-day-picker'

import getMonthAndWeekdayTranslations from '../../../containers/DateNavigator/helpers/getMonthAndWeekdayTranslations'
import { generateEventPath } from '../../../helpers'
import { eachDayOfInterval, formatDate } from '../../../helpers/date'
import Icon from '../../style/Icon/Icon'

import './SingleDateNavigator.scss'

interface SingleDateNavigatorProps {
    type: 'startDate' | 'endDate'
    startDate: Date,
    endDate: Date,
    title: string;
    className?: string;
    onChange: (date: Date) => void,
}

const SingleDateNavigator: FC<SingleDateNavigatorProps> = ({
    startDate,
    endDate,
    type,
    title,
    onChange,
    className = '',
}) => {
    const [active, setActive] = useState(false)
    const selectedDate = type === 'startDate' ? startDate : endDate
    const selectedDays = eachDayOfInterval(startDate, endDate)
    const navigatorDate = formatDate(selectedDate, 'EEEEEE d MMM yyyy')

    const [months, weekDays] = useMemo(() => getMonthAndWeekdayTranslations(), [])

    const weekDaysShort = weekDays.map((d => d.substr(0, 2)))

    const toggleDayPicker = () => {
        setActive(! active)
    }

    const onWindowClick = (e: MouseEvent) => {
        const elements = generateEventPath(e.target)
        const outside = ! elements.find((element: HTMLElement) => element.id === title)
        if (outside) {
            setActive(false)
        }
    }

    const onDayClick = (date: Date) => {
        setActive(false)
        onChange(date)
    }

    useEffect(() => {
        window.addEventListener('click', onWindowClick)
        return () => {
            window.removeEventListener('click', onWindowClick)
        }
    })

    return (
        <div id={title} className={`date-controls single-date-navigator ${className}`}>
            <button type="button" onClick={toggleDayPicker} className="date-controls__button-picker single-date-navigator__button-picker">
                <span className="single-date-navigator__title">
                    {title}
                </span>
                <span className="single-date-navigator__date">
                    {navigatorDate}
                </span>
                <Icon className="single-date-navigator__arrow-down" color="primary" kind="keyboard_arrow_down" />
            </button>
            { active && (
                <div className="single-date-navigator__daypicker">
                    <DayPicker
                        locale="nl"
                        firstDayOfWeek={1}
                        weekdaysShort={weekDaysShort}
                        weekdaysLong={weekDays}
                        months={months}
                        month={selectedDate}
                        selectedDays={selectedDays}
                        showWeekNumbers
                        showOutsideDays
                        onDayClick={onDayClick}
                    />
                </div>
            )}
        </div>
    )
}

export default SingleDateNavigator
